import React, { useEffect } from "react";
import { CustomCheckBox, CustomDropDown, CustomForm, CustomInput } from "../../shared/Input/AllInputs";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton, { PrimaryButtonOutlined } from "../../shared/Button/PrimaryButton";
import OurWorkContainer from "./OurWorkContainer";
import Index from "./index";
import ProductsTable from "./ProductsTable";
import { Dialog } from "primereact/dialog";
import CustomViewImage from "../../shared/Image/CustomViewImage";
import { NewCustomViewImage } from "../../shared/Input/AllViewInputs";

const OurWorkForm = ({ type }) => {
    const { allServices } = Index();
    const {
        data,
        history,
        handleChange,
        setFormType,
        loading,
        addWork,
        product,
        editProduct,
        handleProductChange,
        createProduct,
        showAddProductDialog,
        setShowAddProductDialog,
        onDeleteProduct,
    } = OurWorkContainer();

    useEffect(() => {
        setFormType(type);
    }, [type, setFormType]);

    return (
        <>
            {/* pointerEvents: "none" */}
            <CustomForm style={type === "VIEW" ? {} : {}}>
                <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                    <div className="grid col-8">
                        <CustomInput col={5} key="name" label="Name" name="name" data={data} onChange={handleChange} disabled={type === "VIEW"} />
                        <CustomDropDown
                            col={7}
                            key="service"
                            label="Service"
                            name="service"
                            placeholder="Service"
                            options={allServices}
                            optionLabel="serviceName"
                            optionValue="_id"
                            data={data}
                            onChange={handleChange}
                            disabled={type === "VIEW"}
                        />
                    </div>
                    <div className="grid col-8">
                        {/* <CustomInput label="Description" name="description" extraClassName="my-auto" data={data} onChange={handleChange} col={12} /> */}
                    </div>
                    <div className="col-12 grid surface-100 border-round-xl p-4 mb-3">
                        <CustomCheckBox
                            key="hasBeforeAfterImages"
                            label={"Has Before After Images"}
                            name="hasBeforeAfterImages"
                            data={data}
                            onChange={handleChange}
                            col={12}
                            disabled={type === "VIEW"}
                        />

                        {data?.hasBeforeAfterImages ? (
                            <>
                                {type === "VIEW" ? <>
                                    {data?.beforeImage && <NewCustomViewImage image={data?.beforeImage} label="Before Image" />}
                                    {data?.afterImage && <NewCustomViewImage image={data?.afterImage} label="After Image" />}
                                </> : <>
                                    <CustomImageInput
                                        name="beforeImage"
                                        label="Before Image"
                                        key="beforeImage"
                                        data={data}
                                        editable={true}
                                        onFilesChange={handleChange}
                                        col={3}
                                    />
                                    <CustomImageInput
                                        key="afterImage"
                                        name="afterImage"
                                        label="After Image"
                                        data={data}
                                        editable={true}
                                        onFilesChange={handleChange}
                                        col={3}
                                    />
                                </>}


                            </>
                        ) : (
                            <>
                                <CustomImageInput
                                    key="simgleImage"
                                    name="simgleImage"
                                    label="Single Image"
                                    data={data}
                                    editable={true}
                                    onFilesChange={handleChange}
                                    col={3}
                                />
                            </>
                        )}
                    </div>
                </div>
            </CustomForm>
            {type !== "ADD" && (
                <>
                    {type === "EDIT" ? (
                        <div className="w-full text-left mb-3">
                            <PrimaryButton extraClassName="w-2" label="Add Product" loading={loading} onClick={setShowAddProductDialog} />
                        </div>
                    ) : null}
                    <div className="mb-3">
                        <ProductsTable
                            heading={"Service Items"}
                            items={data?.products}
                            onEdit={(product) => editProduct(product)}
                            onDelete={(e, id, workId) => onDeleteProduct(e, id, workId)}
                            formType={type}
                        />
                    </div>
                </>
            )}
            <div className="flex mb-3 justify-content-end">
                {type !== "VIEW" && (
                    <PrimaryButton
                        extraClassName="lg:w-3 w-6"
                        label={type === "EDIT" ? "Update Work" : "Add Work"}
                        loading={loading}
                        onClick={addWork}
                    />
                )}
                <PrimaryButtonOutlined extraClassName="lg:w-3 w-6" label="Cancel" onClick={() => history.push("/our-works")} />
            </div>

            <Dialog
                visible={showAddProductDialog}
                style={{ width: "30vw" }}
                onHide={() => {
                    if (!showAddProductDialog) return;
                    setShowAddProductDialog(false);
                }}
            >
                <div className="w-full">
                    <CustomInput col={12} key="title" label="Title" name="title" data={product} onChange={handleProductChange} />
                    <CustomInput col={12} key="subTitle" label="Sub Title" name="subTitle" data={product} onChange={handleProductChange} />
                    {/* <CustomInput col={12} key="description" label="Description" name="description" data={product} onChange={handleProductChange} /> */}
                    <CustomImageInput
                        name="image"
                        label="Image"
                        key="image"
                        data={product}
                        editable={true}
                        onFilesChange={handleProductChange}
                        col={3}
                    />
                    <CustomInput col={12} key="url" label="Url" name="url" data={product} onChange={handleProductChange} />
                </div>

                <div className="flex w-full mb-3 justify-content-end">
                    {type === "EDIT" && (
                        <PrimaryButton label={product?._id ? "Update Product" : "Add Product"} loading={loading} onClick={createProduct} />
                    )}
                    <PrimaryButtonOutlined
                        label="Cancel"
                        onClick={() => {
                            setShowAddProductDialog(false);
                        }}
                    />
                </div>
            </Dialog>
        </>
    );
};

export default OurWorkForm;
